import { v4 as uuidv4 } from "uuid";

/*
 * Generate a new value for a cookie.
 * Using UUIDv4, as this gives is very good uniqueness, as
 * defined by https://www.ietf.org/rfc/rfc4122.txt
 *
 * Abstracted as the customer has requested the removal of hyphens
 */
export const generateRandomCookieValue = (): string => {
    return uuidv4().replaceAll(/[^A-Za-z0-9]/g, "");
};

export type nowPlusNProps = {
    nDays?: number;
    nMinutes?: number;
};

type nowPlusNType = (props: nowPlusNProps) => Date;

/*
 * Get the Date `n` days and/or minutes from now, for use in a cookie expiry parameter
 * https://stackoverflow.com/a/19691491
 * cookies.set({ expires: ... }) expects to be a date object.
 */
export const nowPlusN: nowPlusNType = ({ nDays, nMinutes }) => {
    const result = new Date();
    if (nDays) {
        result.setDate(result.getDate() + nDays);
    }
    if (nMinutes) {
        result.setMinutes(result.getMinutes() + nMinutes);
    }
    return result;
};
